/**
 * Reports page — Site Compliance Assessment, split into two segments:
 *
 *   1. Monthly Assessment   — Hygiene, Cleanliness, CCP Data, CCP Deviations
 *                             scored for ONE calendar month.
 *   2. Period Assessment    — Incidents/NCR, Training, Calibration, FSMS Team,
 *                             Pest Control, Approved Vendor scored across a
 *                             Start → End month window (inclusive).
 *
 * Each ready pillar exposes its own "File in Vault" action where the
 * vault type exists. The Audit Vault page shows historical snapshots +
 * per-record actions. Per-form ISO / Emergency tiles were retired
 * (2026-06-22) — their PDF preview + per-record filing affordances now
 * live inside the Vault.
 */
import { useEffect, useState } from "react";
import api from "@/lib/api";
import AssessmentPanel from "../components/reports/AssessmentPanel";
import CriticalTaskList from "../components/reports/CriticalTaskList";

export default function Reports() {
  const [sites, setSites] = useState([]);

  useEffect(() => { (async () => {
    try {
      const { data } = await api.get("/sites");
      setSites(data.sites || []);
    } catch (e) { console.debug("Reports sites load failed:", e); }
  })(); }, []);

  return (
    <div className="vb-fade-in pb-24 lg:pb-0" data-testid="reports-page">
      <h1 className="vb-heading text-3xl mb-1" style={{ color: "var(--vb-text-2)" }}>
        Audit-ready reports
      </h1>
      <p className="opacity-70 mb-6 max-w-3xl">
        Run a <b>site compliance assessment</b> in two segments — a
        monthly view for daily-tracking pillars, and a period view for
        incidents and standing documentation. Each ready pillar can be
        filed into the <b>Audit Vault</b> for sign-off, where downloadable
        PDFs and the audit trail live.
      </p>

      <CriticalTaskList />

      <AssessmentPanel sites={sites} mode="monthly" onAssessmentReady={() => {}} />
      <AssessmentPanel sites={sites} mode="period"  onAssessmentReady={() => {}} />
    </div>
  );
}
